import BootstrapTable from "react-bootstrap-table-next";
import styled from "styled-components";
import { useEffect, useRef, useState } from "react";
import Skeleton from "react-loading-skeleton";
import filterFactory from "react-bootstrap-table2-filter";
import _ from "lodash";

import Card from "./Card";
import { ReactComponent as EmptyFileIcon } from "../resources/icons/empty-file.svg";

export default function DataTable({
  disablePagination = true,
  disableSelect = false,
  columns,
  data,
  onSelect,
  onRowClick = (row, rowIndex) => { },
  sort,
  keyField = "id",
  bordered = true,
  hover = false,
  rowStyle,
  expandRow,
  headerClasses,
  pagination = false,
}) {
  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      onRowClick(row, rowIndex);
    },
  };

  const selectRowProp = {
    selectRow: disableSelect
      ? { hideSelectColumn: true }
      : {
        mode: "checkbox",
        onSelect: onSelect,
        selectColumnStyle: { verticalAlign: "middle" },
      },
  };
  const sortObj = sort || {
    dataField: "dateCreation",
    order: "desc",
    sortFunc: sortDateFunc,
  };

  return (
    <>
      <BootstrapTable
        headerClasses={headerClasses}
        bootstrap4
        expandRow={expandRow}
        rowStyle={rowStyle}
        hover={hover}
        bordered={false}
        sort={sortObj}
        filter={filterFactory()}
        keyField={keyField}
        {...selectRowProp}
        rowEvents={rowEvents}
        columns={columns}
        data={data}
      />
      {data.length === 0 && <EmptyTable />}
    </>
  );
}

export const CustomTableCellContainer = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;

  &:focus {
    box-shadow: 0 0 0 2px #68717840;
  }
  border: none;
  outline: none;
`;

export const EmptyTableContainer = styled.div`
  margin-top: -1rem;
  width: 100%;
  height: 40;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: solid 1px #dee2e6;
  border-left: solid 1px #dee2e6;
  border-right: solid 1px #dee2e6;
  height: 150px;
`;

export function EmptyTable() {
  return (
    <EmptyTableContainer>
      <div>
        <EmptyFileIcon fill="#6c757d" />
        <p className="text-muted">Empty</p>
      </div>
    </EmptyTableContainer>
  );
}

export function useTableSort() {
  const [sortInfo, setSortInfo] = useState(null);
  const [reset, setRest] = useState(0);

  const changeSortOrder = () => {
    if (!sortInfo) return;
    setRest((prev) => prev + 1);
    if (reset === 2) {
      setRest(0);
      setSortInfo(null);
      return;
    }
    const order = sortInfo.sort.order === "asc" ? "desc" : "asc";
    setSortInfo((prev) => ({
      text: prev.text,
      sort: { ...prev.sort, order },
    }));
  };

  return { sortInfo, changeSortOrder, setSortInfo };
}

export function useTableSearch(data) {
  const [searchKeywords, setSearchKeywords] = useState([]);

  const onChange = (key) => (e) => {
    setSearchKeywords((prev) => ({ ...prev, [key]: e.target.value }));
  };

  return {
    searchKeywords,
    onChange,
    filteredData: filterObjects(data, searchKeywords),
  };
}

export function SortButton({
  changeSortOrder,
  sortInfo,
  showDropdown,
  sortConfig,
  setShowDropdown,
  setSortInfo,
}) {
  function toggleSortingDropdown() {
    setShowDropdown(!showDropdown);
  }

  const ref = useRef(null);

  useEffect(() => {
    if (showDropdown)
      document.addEventListener("mousedown", handleClickOutside);
    else document.removeEventListener("mousedown", handleClickOutside);
    function handleClickOutside(e) {
      if (ref.current && !ref.current.contains(e.target))
        setShowDropdown(false);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [ref, showDropdown, setShowDropdown]);

  return (
    <div style={{ marginLeft: "auto" }} className="btn-group" role="group">
      <button
        onClick={changeSortOrder}
        type="button"
        style={{
          minWidth: "40px",
          height: "100%",
          padding: 0,
          margin: 0,
        }}
        className="btn btn-app"
      >
        {sortInfo?.sort?.order === "asc" ? (
          <i style={{ fontSize: 18 }} className="fas fa-sort-amount-up"></i>
        ) : (
          <i style={{ fontSize: 18 }} className="fas fa-sort-amount-down"></i>
        )}
      </button>

      <div className="btn-group">
        <button
          onClick={toggleSortingDropdown}
          type="button"
          className="btn btn-secondary dropdown-toggle"
        >
          {sortInfo?.text}
        </button>

        {showDropdown && (
          <div
            ref={ref}
            style={{ left: "auto", right: 0 }}
            className="dropdown-menu show"
          >
            {sortConfig.map(({ text, sort }) => (
              <li
                onClick={() => {
                  setSortInfo({ text, sort });
                  setShowDropdown(false);
                }}
                key={text}
                style={{ cursor: "pointer" }}
                className="dropdown-item"
              >
                {text}
              </li>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

export function DataTableLoadingSkeleton() {
  return (
    <Card style={{ minHeight: "80vh", overflow: "hidden" }}>
      <Card.Header>
        <div className="row" style={{ gap: 10 }}>
          <div>
            <Skeleton width={83} height={25} />
          </div>
          <div>
            {/* <Form.Input
              onChange={onChange("article.code")}
              size="sm"
              placeholder="Article"
            /> */}
            <Skeleton width={83} height={25} />
          </div>

          {/* <SortButton
            changeSortOrder={changeSortOrder}
            sortInfo={sortInfo}
            sortConfig={sortConfig}
            setShowDropdown={setSortingDropdown}
            showDropdown={sortingDropdown}
            setSortInfo={setSortInfo}
          /> */}
          <div className="ml-auto">
            <Skeleton width={83} height={25} />
          </div>
          <div>
            <Skeleton width={83} height={25} />
          </div>

          {/* <Link to="/bom/new" className="btn btn-secondary ml-2">
            Ajouter
          </Link> */}
        </div>
      </Card.Header>
      <Card.Body style={{ minHeight: "100%" }}>
        {/* <DataTable
          hover={true}
          sort={sortInfo?.sort}
          columns={columns}
          data={filteredData}
          key="id"
        /> */}
        <table style={{ height: "100%" }} className="table table-bordered">
          <thead>
            <tr>
              <th scope="col">
                <Skeleton height={30} />
              </th>
              <th scope="col">
                <Skeleton height={30} />
              </th>
              <th scope="col">
                <Skeleton height={30} />
              </th>
              <th scope="col">
                <Skeleton height={30} />
              </th>
            </tr>
          </thead>
          <tbody>
            {[1, 2, 1, 2, 1, 8, 9].map((row, index) => (
              <tr key={index}>
                <td>
                  <Skeleton height={30} />
                </td>
                <td>
                  <Skeleton height={30} />
                </td>

                <td>
                  <Skeleton height={30} />
                </td>
                <td>
                  <Skeleton height={30} />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </Card.Body>
    </Card>
  );
}

function filterObjects(objects, keywords) {
  if (objects.length === 0) return objects;
  return objects.filter((obj) => {
    return Object.keys(keywords).reduce((prev, cur) => {
      return (
        prev &&
        _.get(obj, cur)?.toLowerCase()?.startsWith(keywords[cur].toLowerCase())
      );
    }, true);
  });
}

export const sortDateFunc = (a, b, order, _dataField) => {
  const dateA = new Date(a);
  const dateB = new Date(b);

  if (order === "asc") {
    return dateA - dateB;
  } else if (order === "desc") {
    return dateB - dateA;
  }

  return 0;
};
